import { useEffect, useState } from "react"
import { debounce } from "lodash"
import { downloadReceiptData } from "../../helpers/downloadToExcel"

function Filter({
    usersInCriteria,
    setSelectedUsers,
    selectedUsers,
    compliesWithFilters,
    chargerNameIdPair
}) {
    const [userSearchResults, setUserSearchResults] = useState(usersInCriteria)
    const [toggleUsersDropdown, setToggleUsersDropdown] = useState(false)

    useEffect(() => {
        setUserSearchResults(usersInCriteria)
    }, [usersInCriteria])

    // This debounce function changes what users are show
    // for the operator to select
    const changeUserSearchResults = debounce((string) => {
        const searchString = string.toLowerCase()
        if(searchString === "") {
            setUserSearchResults(usersInCriteria)
            return
        }
        const filteredResults = usersInCriteria.filter(
            user => user.toLowerCase().includes(searchString.toLowerCase())
        )
        setUserSearchResults(filteredResults)
    }, 200)

    // This function adds or removes a selected user 
    function addOrRemoveUser(user) {
        setSelectedUsers(prev => {
            if (prev.includes(user)) {
                return prev.filter(existingUser => existingUser !== user);
            } else {
                return [...prev, user];
            }
        });
    }

    return (
        <div className="h-10 w-full bg-white border-t-[1px] border-b-[1px] border-gray-300 flex items-center pl-2 pr-2">
            <div className="relative">
                <button
                    className={`${(usersInCriteria === selectedUsers || selectedUsers.length === 0) ? "border-gray-300 bg-gray-100" : "border-blue-300 bg-blue-100"} border-[1px] rounded-md h-6 pl-1 pr-1 text-sm flex items-center`}
                    onClick={() => setToggleUsersDropdown(!toggleUsersDropdown)}>
                    <h4>Users</h4>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 ml-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                {toggleUsersDropdown && (
                    <div className="w-72 h-72 overflow-y-scroll overflow-x-hidden bg-white z-[1000] policyFormScrollBar absolute border-[1px] border-gray-300 mt-1 rounded-lg p-1 shadow-2xl">
                        <input type="text" placeholder="Search for a user" className={`text-sm pl-2 pr-2 h-7 rounded-full border-[1px] border-gray-400`} onChange={(e) => changeUserSearchResults(e.target.value)}></input>
                        {userSearchResults.map((result, index) => (
                            <button className={`${selectedUsers.includes(result) ? "bg-blue-100 border-[1px] border-secondaryAccent" : "bg-white"} w-full text-left text-sm pl-2 p-1`} onClick={() => addOrRemoveUser(result)} key={index}>{result}</button>
                        ))}
                    </div>
                )}
            </div>
                <button className="ml-2" onClick={() => downloadReceiptData(compliesWithFilters, chargerNameIdPair)}>
                    Download
                </button>
        </div>
    )
}

export default Filter